<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-header-2">
                                <h5>Order Information</h5>
                            </div>
                            
                            <v-form class="theme-form theme-form-2 mega-form" ref="form">
                                <div class="order-information-fields">
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Order Number</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Order Number" v-model="orderNumber" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Order Status</label>
                                        <div class="col-sm-10">
                                            <v-combobox
                                                label="Search status..."
                                                :items="dataOrderStatusCombo"
                                                item-title="name"
                                                item-value="id"
                                                v-model="orderStatus"
                                                variant="outlined"
                                            ></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Address</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Address" v-model="address"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Address number</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Address number" v-model="addressnumber"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Country</label>
                                        <div class="col-sm-10">
                                            <v-combobox
                                                label="Search country..."
                                                :items="dataCountryCombo"
                                                item-title="name"
                                                item-value="id"
                                                v-model="country"
                                                variant="outlined"
                                            ></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Province</label>
                                        <div class="col-sm-10">
                                            <v-combobox
                                                label="Search province..."
                                                :items="dataProvinceCombo"
                                                item-title="name"
                                                item-value="id"
                                                v-model="province"
                                                variant="outlined"
                                            ></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">City</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="City" v-model="city"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Postal code</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Postal code" v-model="postalcode"></v-text-field>
                                        </div>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">User Email</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="User Email" v-model="user" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Customer Name</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Customer Name" v-model="customerName" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Phone</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Phone" v-model="customerPhone" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Document</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Document" v-model="customerDocument" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Voucher Number</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Voucher Number" v-model="voucherNumber" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">CJ Dropshipping ID</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="CJ Request ID" v-model="cjDropshippingId" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="cjWebhookSyncStatus">
                                    <div class="mb-4 col-sm-12">
                                        <v-alert
                                            :type="cjWebhookSyncStatus.color"
                                            :icon="cjWebhookSyncStatus.icon"
                                            variant="tonal"
                                            density="comfortable"
                                            :title="cjWebhookSyncStatus.title"
                                            :text="cjWebhookSyncStatus.text"
                                        ></v-alert>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Created At</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Created At" v-model="createdAt" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Updated At</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Updated At" v-model="updatedAt" disabled></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Total (USD)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Total" v-model="total"></v-text-field>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Details order:</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive table-desi table-product">
                                                    <v-data-table-server
                                                        class="table table-1d all-package"
                                                        v-model:items-per-page="itemsPerPage"
                                                      
                                                        :items-length="pagination.total"
                                                        :items="dataDetailOrderGrid"
                                                        :loading="loading"
                                                        :headers="detailOrderHeaders"
                                                        
                                                        @update:options="getDetailOrderGrid"
                                                    >
                                                        <template #item.price="{ item }">
                                                            {{ formatCurrency(item.price, 'USD') }}
                                                        </template>
                                                        <template #item.discount="{ item }">
                                                            {{ formatPercent(item.discount) }}
                                                        </template>
                                                        <template #item.line_total="{ item }">
                                                            {{ formatCurrency(item.line_total, 'USD') }}
                                                        </template>
                                                    </v-data-table-server>  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Shipping order:</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive table-desi table-product">
                                                    <v-data-table-server
                                                        class="table table-1d all-package"
                                                        v-model:items-per-page="itemsPerPageShipping"
                                                      
                                                        :items-length="paginationShipping.total"
                                                        :items="dataShippingOrderGrid"
                                                        :loading="loading"
                                                        :headers="shippingOrderHeaders"

                                                        @update:options="getShippingOrderGrid"
                                                    >
                                                        <template #item.last_track_number="{ item }">
                                                            <span v-if="!item.last_track_number">-</span>
                                                            <template v-else>
                                                                <a :href="get17TrackUrl(item.last_track_number)" target="_blank" rel="noopener noreferrer">{{ item.last_track_number }}</a>
                                                                <template v-if="item.last_mile_carrier"> ({{ item.last_mile_carrier }})</template>
                                                            </template>
                                                        </template>
                                                        <template #item.tracking_history_action="{ item }">
                                                            <v-btn
                                                                size="small"
                                                                variant="outlined"
                                                                color="secondary"
                                                                :disabled="!item.tracking_events || !item.tracking_events.length"
                                                                @click.stop="openTrackingHistory(item)"
                                                            >
                                                                Ver historial ({{ item.tracking_events ? item.tracking_events.length : 0 }})
                                                            </v-btn>
                                                        </template>
                                                    </v-data-table-server>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Shipment Notification order:</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive table-desi table-product">
                                                    <v-data-table-server
                                                        class="table table-1d all-package"
                                                        v-model:items-per-page="itemsPerPageShipmentNotification"
                                                      
                                                        :items-length="paginationShipmentNotification.total"
                                                        :items="dataShipmentNotificationOrderGrid"
                                                        :loading="loading"
                                                        :headers="shipmentNotificationHeaders"
                                                        
                                                        @update:options="getShipmentNotificationOrderGrid"
                                                    >
                                                                                       
                                                    </v-data-table-server>  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Transactions order:</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="row g-3">
                                                    <div class="col-sm-6 col-lg-3">
                                                        <div class="border rounded p-3 h-100">
                                                            <div class="text-muted small">Total pedido ({{ checkoutCurrency }})</div>
                                                            <div class="fw-bold fs-6">{{ formatCurrency(financialSummary.orderTotal, checkoutCurrency) }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 col-lg-3">
                                                        <div class="border rounded p-3 h-100">
                                                            <div class="text-muted small">Total cobrado ({{ checkoutCurrency }})</div>
                                                            <div class="fw-bold fs-6 text-success">{{ formatCurrency(financialSummary.chargedTotal, checkoutCurrency) }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 col-lg-3">
                                                        <div class="border rounded p-3 h-100">
                                                            <div class="text-muted small">Total reembolsado ({{ checkoutCurrency }})</div>
                                                            <div class="fw-bold fs-6 text-warning">{{ formatCurrency(financialSummary.refundedTotal, checkoutCurrency) }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 col-lg-3">
                                                        <div class="border rounded p-3 h-100">
                                                            <div class="text-muted small">Pendiente ({{ checkoutCurrency }})</div>
                                                            <div class="fw-bold fs-6" :class="financialSummary.pendingTotal > 0 ? 'text-danger' : 'text-success'">{{ formatCurrency(financialSummary.pendingTotal, checkoutCurrency) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="row g-3 mb-3">
                                                    <div class="col-sm-12 col-md-4">
                                                        <v-text-field
                                                            v-model="transactionFilters.query"
                                                            label="Buscar transaccion"
                                                            placeholder="Numero, payment intent, charge"
                                                            variant="outlined"
                                                            density="comfortable"
                                                            clearable
                                                        ></v-text-field>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4">
                                                        <v-select
                                                            v-model="transactionFilters.status"
                                                            :items="transactionStatusFilterOptions"
                                                            label="Estado pago"
                                                            variant="outlined"
                                                            density="comfortable"
                                                            clearable
                                                        ></v-select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4">
                                                        <v-select
                                                            v-model="transactionFilters.method"
                                                            :items="transactionMethodFilterOptions"
                                                            label="Metodo de pago"
                                                            variant="outlined"
                                                            density="comfortable"
                                                            clearable
                                                        ></v-select>
                                                    </div>
                                                </div>
                                                <div class="mb-3" v-if="paymentValidationAlerts.length">
                                                    <v-alert
                                                        v-for="(alert, index) in paymentValidationAlerts"
                                                        :key="`payment-alert-${index}`"
                                                        :type="alert.type"
                                                        variant="tonal"
                                                        class="mb-2"
                                                        :text="alert.message"
                                                    ></v-alert>
                                                </div>
                                                <div class="d-flex flex-wrap ga-2 mb-3">
                                                    <v-btn color="primary" variant="outlined" :loading="adminActionLoading" @click="openAdminActionDialog('resend')">Reenviar correo confirmacion</v-btn>
                                                    <v-btn color="secondary" variant="outlined" :loading="adminActionLoading" :disabled="!isRefundDisabled" @click="openAdminActionDialog('refund_email')">Enviar correo reembolso</v-btn>
                                                    <v-btn color="info" variant="outlined" :loading="adminActionLoading" @click="openAdminActionDialog('review')">Marcar revisado</v-btn>
                                                    <v-btn color="warning" variant="outlined" :loading="adminActionLoading" :disabled="isRefundDisabled" @click="openAdminActionDialog('refund')">Solicitar reembolso</v-btn>
                                                </div>
                                                <div class="table-responsive table-desi table-product transaction-order-table">
                                                    <v-data-table-server
                                                        class="table table-1d all-package transaction-order-data-table"
                                                        v-model:items-per-page="itemsPerPageTransactionOrder"
                                                        :items-length="filteredTransactionRows.length"
                                                        :items="filteredTransactionRows"
                                                        :loading="loading"
                                                        :headers="transactionOrderHeaders"
                                                        @update:options="getTransactionOrderGrid"
                                                    >
                                                        <template #item.transaction_number="{ item }">
                                                            <div class="d-flex align-center ga-2">
                                                                <span>{{ item.transaction_number }}</span>
                                                                <v-btn size="x-small" variant="text" color="primary" @click="copyToClipboard(item.transaction_number, 'Transaction number copiado')">Copiar</v-btn>
                                                            </div>
                                                        </template>
                                                        <template #item.payment_intent_id="{ item }">
                                                            <div class="d-flex align-center ga-2">
                                                                <span>{{ item.payment_intent_id }}</span>
                                                                <v-btn size="x-small" variant="text" color="primary" @click="copyToClipboard(item.payment_intent_id, 'Payment intent copiado')">Copiar</v-btn>
                                                            </div>
                                                        </template>
                                                        <template #item.charge_id="{ item }">
                                                            <div class="d-flex align-center ga-2">
                                                                <span>{{ item.charge_id }}</span>
                                                                <v-btn size="x-small" variant="text" color="primary" @click="copyToClipboard(item.charge_id, 'Charge ID copiado')">Copiar</v-btn>
                                                            </div>
                                                        </template>
                                                        <template #item.total="{ item }">
                                                            {{ formatCurrency(item.total, item.checkout_currency || checkoutCurrency) }}
                                                        </template>
                                                        <template #item.status_label="{ item }">
                                                            <v-chip size="small" :color="item.status_color" label>{{ item.status_label }}</v-chip>
                                                        </template>
                                                        <template #item.actions="{ item }">
                                                            <v-btn size="small" variant="outlined" color="secondary" @click.stop="openTransactionDetail(item)">Ver detalle</v-btn>
                                                        </template>
                                                    </v-data-table-server>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Order Status History:</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive table-desi table-product">
                                                    <v-data-table-server
                                                        class="table table-1d all-package"
                                                        v-model:items-per-page="itemsPerPageStatusHistory"
                                                      
                                                        :items-length="paginationStatusHistory.total"
                                                        :items="dataStatusHistoryGrid"
                                                        :loading="loading"
                                                        :headers="statusHistoryHeaders"
                                                        
                                                        @update:options="getStatusHistoryGrid"
                                                    ></v-data-table-server>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4 row align-items-center d-flex justify-content-between">
                                        <label class="form-label-title col-sm-6 mb-0">CJ Sync Log (auditoría técnica):</label>
                                        <div class="col-sm-6 text-end">
                                            <v-btn size="small" variant="tonal" color="primary" @click="goToOrderLogs">Ver todos los logs de este pedido</v-btn>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive table-desi table-product">
                                                    <v-data-table
                                                        class="table table-1d all-package"
                                                        :items="cjSyncLogs"
                                                        :headers="cjSyncLogsHeaders"
                                                        no-data-text="No hay eventos de sincronización CJ registrados para este pedido"
                                                    >
                                                        <template #item.detalle_action="{ item }">
                                                            <v-btn
                                                                size="small"
                                                                variant="tonal"
                                                                @click.stop="openCjSyncLogDetail(item)"
                                                            >Ver contexto</v-btn>
                                                        </template>
                                                    </v-data-table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex flex-column">
                                    <v-btn class="mt-4" color="success" block @click="validate"> Update </v-btn>
                                </div>
                            </v-form>
                        </div>

                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                        <v-dialog v-model="adminActionDialog.open" max-width="680">
                            <v-card>
                                <v-card-title>{{ adminActionDialog.title }}</v-card-title>
                                <v-card-text>
                                    <v-textarea
                                        v-model="adminActionDialog.reason"
                                        label="Motivo"
                                        placeholder="Escribe el motivo de esta accion"
                                        variant="outlined"
                                        bg-color="white"
                                        color="primary"
                                        class="admin-action-textarea"
                                        rows="4"
                                        auto-grow
                                    ></v-textarea>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn variant="text" @click="adminActionDialog.open = false">Cancelar</v-btn>
                                    <v-btn color="primary" :loading="adminActionLoading" @click="submitAdminActionDialog">Confirmar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="isTransactionDetailDialogOpen" max-width="900">
                            <v-card>
                                <v-card-title>Detalle de transaccion</v-card-title>
                                <v-card-text>
                                    <div v-if="selectedTransaction">
                                        <div class="row g-3">
                                            <div class="col-sm-6"><strong>Numero:</strong> {{ selectedTransaction.transaction_number }}</div>
                                            <div class="col-sm-6"><strong>Metodo:</strong> {{ selectedTransaction.method }}</div>
                                            <div class="col-sm-6"><strong>Estado:</strong> {{ selectedTransaction.status_label }}</div>
                                            <div class="col-sm-6"><strong>Estado gateway:</strong> {{ selectedTransaction.payment_status }}</div>
                                            <div class="col-sm-6"><strong>Total:</strong> {{ formatCurrency(selectedTransaction.total, selectedTransaction.checkout_currency || checkoutCurrency) }}</div>
                                            <div class="col-sm-6"><strong>Last4:</strong> {{ selectedTransaction.last4 }}</div>
                                            <div class="col-sm-6"><strong>Created At:</strong> {{ selectedTransaction.created_at }}</div>
                                            <div class="col-sm-6"><strong>Updated At:</strong> {{ selectedTransaction.updated_at }}</div>
                                            <div class="col-sm-12 d-flex align-center ga-2">
                                                <strong>Payment Intent ID:</strong> <span>{{ selectedTransaction.payment_intent_id }}</span>
                                                <v-btn size="x-small" variant="text" color="primary" @click="copyToClipboard(selectedTransaction.payment_intent_id, 'Payment intent copiado')">Copiar</v-btn>
                                            </div>
                                            <div class="col-sm-12 d-flex align-center ga-2">
                                                <strong>Charge ID:</strong> <span>{{ selectedTransaction.charge_id }}</span>
                                                <v-btn size="x-small" variant="text" color="primary" @click="copyToClipboard(selectedTransaction.charge_id, 'Charge ID copiado')">Copiar</v-btn>
                                            </div>
                                            <div class="col-sm-12"><strong>Gateway ref:</strong> {{ selectedTransaction.balance_transaction_id }}</div>
                                            <div class="col-sm-12">
                                                <strong>Metadata:</strong>
                                                <pre class="p-2 border rounded bg-light mb-0" style="white-space: pre-wrap; color: #000000;">{{ selectedTransaction.payment_metadata_text }}</pre>
                                            </div>
                                            <div class="col-sm-12">
                                                <strong>Respuesta gateway:</strong>
                                                <pre class="p-2 border rounded bg-light mb-0" style="white-space: pre-wrap; color: #000000;">{{ selectedTransaction.gateway_response_text }}</pre>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn variant="text" @click="isTransactionDetailDialogOpen = false">Cerrar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="isTrackingHistoryDialogOpen" max-width="700">
                            <v-card>
                                <v-card-title>Historial de seguimiento</v-card-title>
                                <v-card-text>
                                    <div v-if="selectedTrackingHistory">
                                        <div class="row g-3 mb-3">
                                            <div class="col-sm-6"><strong>CJ Order ID:</strong> {{ selectedTrackingHistory.cj_order_id }}</div>
                                            <div class="col-sm-6"><strong>Estado CJ:</strong> {{ selectedTrackingHistory.cj_order_status }}</div>
                                            <div class="col-sm-6"><strong>Tracking Number:</strong> {{ selectedTrackingHistory.tracking_number }}</div>
                                            <div class="col-sm-6"><strong>Estado actual:</strong> {{ selectedTrackingHistory.tracking_status }}</div>
                                            <div class="col-sm-6"><strong>Entrega estimada:</strong> {{ selectedTrackingHistory.estimated_delivery }}</div>
                                            <div class="col-sm-6">
                                                <strong>Tracking local:</strong>
                                                <span v-if="!selectedTrackingHistory.last_track_number">-</span>
                                                <template v-else>
                                                    <a :href="get17TrackUrl(selectedTrackingHistory.last_track_number)" target="_blank" rel="noopener noreferrer">{{ selectedTrackingHistory.last_track_number }}</a>
                                                    <template v-if="selectedTrackingHistory.last_mile_carrier"> ({{ selectedTrackingHistory.last_mile_carrier }})</template>
                                                </template>
                                            </div>
                                            <div class="col-sm-6"><strong>Ruta:</strong> {{ selectedTrackingHistory.tracking_route }}</div>
                                        </div>
                                        <div v-if="selectedTrackingHistory.tracking_events && selectedTrackingHistory.tracking_events.length" class="tracking-history-timeline">
                                            <div v-for="(event, index) in selectedTrackingHistory.tracking_events" :key="index" class="tracking-history-event">
                                                <div class="tracking-history-event-dot"></div>
                                                <div class="tracking-history-event-body">
                                                    <div class="tracking-history-event-date">{{ getTrackingEventDate(event) }}</div>
                                                    <div v-if="getTrackingEventStatus(event)" class="tracking-history-event-status">{{ getTrackingEventStatus(event) }}</div>
                                                    <div class="tracking-history-event-detail">{{ getTrackingEventDetail(event) }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="text-muted">Sin eventos de seguimiento todavía.</div>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn variant="text" @click="isTrackingHistoryDialogOpen = false">Cerrar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="isCjSyncLogDialogOpen" max-width="700">
                            <v-card>
                                <v-card-title>Contexto del log</v-card-title>
                                <v-card-text>
                                    <div v-if="selectedCjSyncLog">
                                        <div class="mb-2"><strong>Fecha:</strong> {{ selectedCjSyncLog.fecha }}</div>
                                        <div class="mb-2"><strong>Nivel:</strong> {{ selectedCjSyncLog.nivel }}</div>
                                        <div class="mb-2"><strong>Mensaje:</strong> {{ selectedCjSyncLog.mensaje }}</div>
                                        <pre class="cj-sync-log-context">{{ JSON.stringify(selectedCjSyncLog.contexto, null, 2) }}</pre>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn variant="text" @click="isCjSyncLogDialogOpen = false">Cerrar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import { ref, onMounted } from 'vue'
import { objectExpression } from '@babel/types'

export default {
    name: 'app',
    title: 'Edit order',
    watch: {
        country() {
            if(this.cargado){
                this.province=null
            }
            if(this.country && this.country.id){
                this.getListProvince(this.country.id)
            } 
            
        },
    },
    data() {
        return {
            cargado:false,
            id: null,
            dataCountryCombo: [],
            dataProvinceCombo: [],
            
            orderNumber : '',                    
            orderStatus: '',
            dataOrderStatusCombo: [],
            dataDetailOrderGrid: [], 

            orderDetails: [],

            total: '',
            user: '',
            customerName: '',
            customerPhone: '',
            customerDocument: '',
            voucherNumber: '',
            cjDropshippingId: '',

            createdAt: '',
            updatedAt: '',

            address: '',
            addressnumber: '',
            country: '',
            province: '',
            city: '',
            postalcode: '',

            //Detalles orden GRID
            dataOrderDetailsGrid: ref([]),
            pagination: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPage: 10,
            detailOrderHeaders: [
                { title: 'Article', key: 'article_name', sortable: false },
                { title: 'Quantity', key: 'quantity', sortable: true },
                { title: 'Unit Price (USD)', key: 'price', sortable: true },
                { title: 'Discount (%)', key: 'discount', sortable: true },
                { title: 'Line Total (USD)', key: 'line_total', sortable: true },
                { title: 'Has Discount', key: 'has_discount', sortable: true }
            ],

            //Detalles Shipping (Envio)
            dataShippingOrderGrid: ref([]),
            paginationShipping: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPageShipping: 10,
            shippingOrderHeaders: [
                { title: 'Shipping ID', key: 'Order_shiping_id', sortable: true },
                { title: 'Producto', key: 'product', sortable: false },
                { title: 'CJ Order ID', key: 'cj_order_id', sortable: false },
                { title: 'Estado CJ', key: 'cj_order_status', sortable: false },
                { title: 'Tracking Number', key: 'tracking_number', sortable: true },
                { title: 'Tracking URL', key: 'tracking_url', sortable: false },
                { title: 'Carrier', key: 'carrier_name', sortable: false },
                { title: 'Tracking local', key: 'last_track_number', sortable: false },
                { title: 'Ruta', key: 'tracking_route', sortable: false },
                { title: 'Estado', key: 'tracking_status', sortable: false },
                { title: 'Entrega estimada', key: 'estimated_delivery', sortable: false },
                { title: 'Description', key: 'description', sortable: false },
                { title: 'Tracking Available', key: 'tracking_available', sortable: true },
                { title: 'Description Length', key: 'description_length', sortable: true },
                { title: 'Historial', key: 'tracking_history_action', sortable: false }
            ],

            //Detalles Notificacion (Envio)
            dataShipmentNotificationOrderGrid: ref([]),
            paginationShipmentNotification: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPageShipmentNotification: 10,
            shipmentNotificationHeaders: [
                { title: 'Shipping ID', key: 'order_shipping_id', sortable: true },
                { title: 'Method', key: 'notification_method', sortable: false },
                { title: 'Status', key: 'order_status', sortable: false },
                { title: 'Comment', key: 'comment', sortable: false },
                { title: 'Has Comment', key: 'has_comment', sortable: true },
                { title: 'Comment Length', key: 'comment_length', sortable: true },
                { title: 'Created At', key: 'created_at', sortable: true },
                { title: 'Updated At', key: 'updated_at', sortable: true }
            ],

            //Detalles Notificacion (Envio)
            dataTransactionOrderGrid: ref([]),
            paginationTransactionOrder: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPageTransactionOrder: 10,
            transactionOrderHeaders: [
                { title: 'Transaction Number', key: 'transaction_number', sortable: true, width: 180 },
                { title: 'Payment Intent ID', key: 'payment_intent_id', sortable: false, width: 220 },
                { title: 'Charge ID', key: 'charge_id', sortable: false, width: 200 },
                { title: 'Total', key: 'total', sortable: true, width: 110 },
                { title: 'Method', key: 'method', sortable: false, width: 140 },
                { title: 'Estado pago', key: 'status_label', sortable: false, width: 140 },
                { title: 'Created At', key: 'created_at', sortable: false, width: 160 },
                { title: 'Updated At', key: 'updated_at', sortable: false, width: 160 },
                { title: 'Last4', key: 'last4', sortable: true, width: 100 },
                { title: 'Detalle', key: 'actions', sortable: false, width: 120 }
            ],
            financialSummary: {
                orderTotal: 0,
                chargedTotal: 0,
                refundedTotal: 0,
                pendingTotal: 0
            },
            transactionFilters: {
                query: '',
                status: null,
                method: null
            },
            checkoutCurrency: 'USD',
            checkoutCurrencyMultiple: 1,
            paymentValidationAlerts: [],
            adminActionLoading: false,
            adminActionDialog: {
                open: false,
                action: null,
                title: '',
                reason: ''
            },
            isTransactionDetailDialogOpen: false,
            selectedTransaction: null,
            isTrackingHistoryDialogOpen: false,
            selectedTrackingHistory: null,

            //Detalles Histórico de Estados
            dataStatusHistoryGrid: ref([]),
            paginationStatusHistory: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPageStatusHistory: 10,
            statusHistoryHeaders: [
                { title: 'ID', key: 'id', sortable: true },
                { title: 'Date', key: 'created_at', sortable: true },
                { title: 'Status', key: 'status_name', sortable: false },
                { title: 'Status ID', key: 'status_id', sortable: true },
                { title: 'Changed By', key: 'user_name', sortable: false },
                { title: 'Changed By Email', key: 'user_email', sortable: false },
                { title: 'Comment', key: 'comment', sortable: false }
            ],

            // Traza tecnica de sincronizacion CJ (log_entries): todos los pasos
            // registrados durante el create/confirm/pay en CJ para este pedido, no
            // solo el ultimo incidente pendiente.
            cjSyncLogs: ref([]),
            cjSyncLogsHeaders: [
                { title: 'Fecha', key: 'fecha', sortable: false },
                { title: 'Nivel', key: 'nivel', sortable: false },
                { title: 'Mensaje', key: 'mensaje', sortable: false },
                { title: 'Detalle', key: 'detalle_action', sortable: false }
            ],
            isCjSyncLogDialogOpen: false,
            selectedCjSyncLog: null,

            loading: false,

            messageError: '',
            typeOfMessage: ''
        }
    },
    computed: {
        filteredTransactionRows() {
            const query = String(this.transactionFilters.query || '').trim().toLowerCase()
            const statusFilter = this.transactionFilters.status
            const methodFilter = this.transactionFilters.method

            return this.dataTransactionOrderGrid.filter((row) => {
                const matchQuery =
                    !query ||
                    String(row.transaction_number || '').toLowerCase().includes(query) ||
                    String(row.payment_intent_id || '').toLowerCase().includes(query) ||
                    String(row.charge_id || '').toLowerCase().includes(query)

                const matchStatus = !statusFilter || String(row.status_label || '') === String(statusFilter)
                const matchMethod = !methodFilter || String(row.method || '') === String(methodFilter)

                return matchQuery && matchStatus && matchMethod
            })
        },
        transactionStatusFilterOptions() {
            const values = this.dataTransactionOrderGrid.map((row) => row.status_label).filter(Boolean)
            return [...new Set(values)]
        },
        transactionMethodFilterOptions() {
            const values = this.dataTransactionOrderGrid.map((row) => row.method).filter(Boolean)
            return [...new Set(values)]
        },
        currentOrderStatusName() {
            if (typeof this.orderStatus === 'object' && this.orderStatus) {
                return String(this.orderStatus.name || '').trim()
            }
            return String(this.orderStatus || '').trim()
        },
        isRefundDisabled() {
            return String(this.currentOrderStatusName).toLowerCase() === 'reembolsado'
        },
        // Indicador visual de si el webhook de Stripe (unico camino que crea el pedido en CJ,
        // ver CheckoutController::handleWebhook) ha llegado a ejecutarse para este pedido, o si
        // solo se proceso por el fallback /status-checkout (que marca Pagado pero nunca sincroniza CJ).
        // Se deriva en cliente de datos ya cargados (cjDropshippingId + cjSyncLogs), sin llamada extra.
        cjWebhookSyncStatus() {
            const paidLikeStatuses = ['pagado', 'enviado', 'entregado', 'reembolsado']
            const statusName = String(this.currentOrderStatusName || '').toLowerCase()
            if (!paidLikeStatuses.includes(statusName)) {
                return null
            }

            const hasCjId = !!this.cjDropshippingId && this.cjDropshippingId !== 'N/A'
            if (hasCjId) {
                return {
                    color: 'success',
                    icon: 'mdi-check-circle',
                    title: 'Webhook de Stripe ejecutado',
                    text: 'El pedido se creo correctamente en CJ Dropshipping (ID: ' + this.cjDropshippingId + ').'
                }
            }

            const webhookRan = this.cjSyncLogs.some((log) => {
                const msg = String(log.mensaje || '')
                return msg.includes('(webhook)')
                    || msg.includes('sincronizacion CJ post-pago')
                    || msg.includes('CJ createOrder')
                    || msg.includes('pendiente de pago en CJ Dropshipping')
            })

            if (webhookRan) {
                return {
                    color: 'warning',
                    icon: 'mdi-alert-circle',
                    title: 'Webhook ejecutado, pedido no creado en CJ',
                    text: 'El webhook de Stripe se ejecuto pero el pedido no quedo creado en CJ. Revisa el detalle del CJ Sync Log de abajo, o usa el reintento desde /admin/order/cj-pending-payment.'
                }
            }

            return {
                color: 'error',
                icon: 'mdi-alert',
                title: 'Webhook de Stripe no recibido',
                text: 'El pago se confirmo por el fallback de status-checkout, pero no hay ningun registro de que el webhook de Stripe haya llegado todavia. El pedido NO se ha creado en CJ. Revisa Stripe Dashboard -> Developers -> Webhooks -> Recent deliveries para este pedido.'
            }
        }
    },
    methods: {
        // Deep link 17TRACK con el número: last_mile_carrier_url es solo la web genérica del
        // transportista (sin número) — mismo criterio que frontend utils/trackingUrl.js.
        get17TrackUrl(trackingNumber) {
            return `https://t.17track.net/es#nums=${encodeURIComponent(String(trackingNumber || "").trim())}`
        },
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        },
        getFormatUpdatedAt(updatedAt) {
            if (!updatedAt) return 'N/A'

            let date = null
            if (typeof updatedAt === 'string' || typeof updatedAt === 'number') {
                date = new Date(updatedAt)
            } else if (updatedAt.timestamp) {
                date = new Date(Number(updatedAt.timestamp) * 1000)
            } else if (updatedAt.date) {
                date = new Date(updatedAt.date)
            }

            if (!date || Number.isNaN(date.getTime())) return 'N/A'

            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },
        getReadableText(value) {
            if (value === null || value === undefined || value === '') return '-'

            if (typeof value === 'object') {
                return value.es || value.en || value.fr || JSON.stringify(value)
            }

            if (typeof value === 'string') {
                const trimmed = value.trim()
                if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
                    try {
                        const parsed = JSON.parse(trimmed)
                        if (parsed && typeof parsed === 'object') {
                            return parsed.es || parsed.en || parsed.fr || value
                        }
                    } catch (e) {
                        return value
                    }
                }
            }

            return value
        },
        formatDate(dateString) {
            if (!dateString) return 'N/A';
            try {
                const date = new Date(dateString);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}`;
            } catch (e) {
                return dateString;
            }
        },
        pickFirstDefined(...values) {
            for (const value of values) {
                if (value !== null && value !== undefined && value !== '') {
                    return value
                }
            }
            return null
        },
        getNumericValue(value) {
            const parsed = Number(value)
            return Number.isFinite(parsed) ? parsed : 0
        },
        normalizeCurrencyCode(currencyCode, fallback = 'USD') {
            const raw = String(currencyCode || '').trim().toUpperCase()
            if (!raw) return fallback
            if (raw === '€' || raw === 'EURO') return 'EUR'
            if (raw === '$' || raw === 'DOLAR' || raw === 'DOLLAR') return 'USD'
            return raw
        },
        formatCurrency(value, currencyCode = null) {
            const numeric = this.getNumericValue(value)
            const normalizedCurrency = this.normalizeCurrencyCode(currencyCode || this.checkoutCurrency || 'USD', 'USD')
            return new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: normalizedCurrency
            }).format(numeric)
        },
        formatPercent(value) {
            const numeric = this.getNumericValue(value)
            return `${numeric}%`
        },
        resolveCheckoutCurrencyContext() {
            const transactionWithCurrency = this.dataTransactionOrderGrid.find((row) => row.checkout_currency)
            const currencyFromRows = transactionWithCurrency?.checkout_currency || 'USD'
            this.checkoutCurrency = this.normalizeCurrencyCode(currencyFromRows, 'USD')

            const transactionWithRate = this.dataTransactionOrderGrid.find((row) => this.getNumericValue(row.checkout_currency_multiple) > 0)
            const rate = this.getNumericValue(transactionWithRate?.checkout_currency_multiple)
            this.checkoutCurrencyMultiple = rate > 0 ? rate : (this.checkoutCurrency === 'USD' ? 1 : 0)
        },
        convertOrderUsdToCheckoutCurrency(orderTotalUsd) {
            const currency = this.normalizeCurrencyCode(this.checkoutCurrency, 'USD')
            if (currency === 'USD') {
                return orderTotalUsd
            }

            const rate = this.getNumericValue(this.checkoutCurrencyMultiple)
            if (rate > 0) {
                return Number((orderTotalUsd * rate).toFixed(2))
            }

            const successfulTransaction = this.dataTransactionOrderGrid.find((row) => row.status_label === 'Pagada')
            if (successfulTransaction) {
                return this.getNumericValue(successfulTransaction.total)
            }

            return orderTotalUsd
        },
        normalizePaymentVisualStatus(paymentStatus, transactionStatus) {
            const payment = String(paymentStatus || '').toLowerCase()
            const txStatus = String(transactionStatus || '').toLowerCase()

            if (payment.includes('refund') || txStatus.includes('reemb')) {
                return { label: 'Reembolsada', color: 'warning' }
            }

            if (
                payment === 'succeeded' ||
                payment === 'paid' ||
                payment === 'captured' ||
                txStatus.includes('complet')
            ) {
                return { label: 'Pagada', color: 'success' }
            }

            if (
                payment.includes('fail') ||
                payment.includes('canceled') ||
                payment.includes('cancelled') ||
                payment.includes('declin') ||
                txStatus.includes('fallid') ||
                txStatus.includes('cancel')
            ) {
                return { label: 'Fallida', color: 'error' }
            }

            return { label: 'Pendiente', color: 'info' }
        },
        parseMetadata(value) {
            if (value === null || value === undefined || value === '') {
                return null
            }

            if (typeof value === 'object') {
                return value
            }

            if (typeof value === 'string') {
                try {
                    return JSON.parse(value)
                } catch (e) {
                    return { raw: value }
                }
            }

            return { raw: String(value) }
        },
        getPaymentMetadataText(metadata) {
            if (!metadata) return '-'
            try {
                return JSON.stringify(metadata, null, 2)
            } catch (e) {
                return String(metadata)
            }
        },
        getGatewayResponseText(item) {
            const response = {
                payment_status: item.payment_status,
                transaction_status: item.status,
                balance_transaction_id: item.balance_transaction_id,
                charge_id: item.charge_id,
                payment_intent_id: item.payment_intent_id
            }
            return JSON.stringify(response, null, 2)
        },
        isOrderPaidStatus() {
            const statusName = typeof this.orderStatus === 'object'
                ? this.getReadableText(this.orderStatus.name)
                : this.getReadableText(this.orderStatus)

            return String(statusName || '').toLowerCase().includes('pagado')
        },
        isOrderRefundedStatus() {
            const statusName = typeof this.orderStatus === 'object'
                ? this.getReadableText(this.orderStatus.name)
                : this.getReadableText(this.orderStatus)

            return String(statusName || '').toLowerCase().includes('reembolsado')
        },
        applyPaymentBusinessValidation() {
            const hasSuccessfulTx = this.dataTransactionOrderGrid.some((row) => row.status_label === 'Pagada')
            const hasRefundedTx = this.dataTransactionOrderGrid.some((row) => row.status_label === 'Reembolsada')
            const orderIsPaid = this.isOrderPaidStatus()
            const orderIsRefunded = this.isOrderRefundedStatus()
            const alerts = []

            if (orderIsPaid && !hasSuccessfulTx) {
                alerts.push({
                    type: 'warning',
                    message: 'Validacion: el pedido esta en Pagado pero no existe transaccion exitosa.'
                })
            }

            if (!orderIsPaid && !orderIsRefunded && hasSuccessfulTx) {
                alerts.push({
                    type: 'error',
                    message: 'Validacion: existe transaccion exitosa y el pedido aun no esta en estado Pagado.'
                })
            }

            if (!orderIsRefunded && hasRefundedTx) {
                alerts.push({
                    type: 'error',
                    message: 'Validacion: existe transaccion de reembolso y el pedido aun no esta en estado Reembolsado.'
                })
            }

            if (orderIsRefunded && !hasRefundedTx) {
                alerts.push({
                    type: 'warning',
                    message: 'Validacion: el pedido esta en Reembolsado pero no existe transaccion de reembolso.'
                })
            }

            this.paymentValidationAlerts = alerts
        },
        updateFinancialSummary() {
            this.resolveCheckoutCurrencyContext()

            const orderTotalUsd = this.getNumericValue(this.total)
            const orderTotal = this.convertOrderUsdToCheckoutCurrency(orderTotalUsd)
            let chargedTotal = 0
            let refundedTotal = 0

            for (const row of this.dataTransactionOrderGrid) {
                const amount = this.getNumericValue(row.total)
                if (row.status_label === 'Pagada') {
                    chargedTotal += amount
                }
                if (row.status_label === 'Reembolsada') {
                    refundedTotal += amount
                }
            }

            const pendingTotal = orderTotal - chargedTotal + refundedTotal

            this.financialSummary = {
                orderTotal,
                chargedTotal,
                refundedTotal,
                pendingTotal
            }

            this.applyPaymentBusinessValidation()
        },
        openTransactionDetail(rowPayload, rowData = null) {
            const row =
                rowData?.item ||
                rowData?.raw ||
                rowPayload?.item ||
                rowPayload?.raw ||
                rowPayload ||
                null
            if (!row) return

            this.selectedTransaction = {
                ...row,
                payment_metadata_text: this.getPaymentMetadataText(row.payment_metadata),
                gateway_response_text: this.getGatewayResponseText(row)
            }
            this.isTransactionDetailDialogOpen = true
        },
        openTrackingHistory(item) {
            this.selectedTrackingHistory = item
            this.isTrackingHistoryDialogOpen = true
        },
        // CJ no publica un esquema cerrado para cada evento de logisticsTrackEvents (solo
        // confirman el ejemplo de trackingStatus como texto libre) — probamos varios nombres
        // de campo plausibles y, si ninguno encaja, mostramos '-' en vez de romper el render.
        getTrackingEventDate(event) {
            return this.pickFirstDefined(event?.trackDate, event?.date, event?.time, event?.eventTime, event?.checkpointDate, event?.trackTime, '-')
        },
        getTrackingEventDetail(event) {
            return this.pickFirstDefined(event?.trackDetail, event?.detail, event?.description, event?.context, event?.remark, event?.trackContent, '-')
        },
        getTrackingEventStatus(event) {
            return this.pickFirstDefined(event?.trackingStatus, event?.status, event?.trackStatus, null)
        },
        async callAdminOrderAction(url, payload, successMessage) {
            try {
                this.adminActionLoading = true
                const response = await axios.post(url, payload, { responseType: 'json' })
                if (response.data?.error) {
                    this.messageError = response.data?.message || 'Operacion no completada'
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data?.message || successMessage
                    this.typeOfMessage = 'success'
                    await this.getStatusHistoryGrid({ page: 1, itemsPerPage: this.itemsPerPageStatusHistory, sortBy: [] })
                }
            } catch (error) {
                this.messageError = 'Error! No se pudo ejecutar la accion administrativa.'
                this.typeOfMessage = 'error'
            } finally {
                this.adminActionLoading = false
                setTimeout(() => (this.messageError = ''), 5000)
            }
        },
        openAdminActionDialog(action) {
            const titles = {
                resend: 'Reenviar correoconfirmacion',
                refund_email: 'Enviar correo de reembolso',
                review: 'Marcar pedido como revisado',
                refund: 'Solicitar reembolso en Stripe'
            }

            const defaultReasons = {
                resend: 'Reenvio solicitado desde administracion.',
                refund_email: 'Correo de reembolso enviado al cliente desde administracion.',
                review: 'Pedido revisado por administracion.',
                refund: 'Solicitud manual de reembolso desde administracion.'
            }

            this.adminActionDialog.action = action
            this.adminActionDialog.title = titles[action] || 'Accion administrativa'
            this.adminActionDialog.reason = defaultReasons[action] || ''
            this.adminActionDialog.open = true
        },
        async submitAdminActionDialog() {
            const reason = String(this.adminActionDialog.reason || '').trim()
            if (!reason) {
                this.messageError = 'Debes indicar un motivo antes de continuar.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 4000)
                return
            }

            const action = this.adminActionDialog.action
            this.adminActionDialog.open = false

            if (action === 'resend') {
                await this.onResendConfirmation(reason)
                return
            }

            if (action === 'review') {
                await this.onMarkReviewed(reason)
                return
            }

            if (action === 'refund_email') {
                await this.onSendRefundEmail(reason)
                return
            }

            if (action === 'refund') {
                const secondConfirm = window.confirm('Confirmacion final: esto ejecuta un reembolso REAL en Stripe. Deseas continuar?')
                if (!secondConfirm) {
                    return
                }
                await this.onRequestRefund(reason, true, true)
            }
        },
        async onResendConfirmation(reason = '') {
            await this.callAdminOrderAction(
                process.env.VUE_APP_URL_API_BASE + '/admin/order/resend-confirmation',
                { id: this.id, comment: reason },
                'Confirmacion reenviada'
            )
        },
        async onMarkReviewed(reason = '') {
            await this.callAdminOrderAction(
                process.env.VUE_APP_URL_API_BASE + '/admin/order/mark-reviewed',
                { id: this.id, comment: reason },
                'Pedido marcado como revisado'
            )
        },
        async onSendRefundEmail(reason = '') {
            await this.callAdminOrderAction(
                process.env.VUE_APP_URL_API_BASE + '/admin/order/send-refund-email',
                { id: this.id, comment: reason },
                'Correo de reembolso enviado'
            )
        },
        async onRequestRefund(reason = '', confirmStepOne = false, confirmStepTwo = false) {
            await this.callAdminOrderAction(
                process.env.VUE_APP_URL_API_BASE + '/admin/order/request-refund',
                {
                    id: this.id,
                    reason,
                    confirm_step_one: !!confirmStepOne,
                    confirm_step_two: !!confirmStepTwo,
                    idempotency_key: `refund_order_${this.id}`
                },
                'Solicitud de reembolso registrada'
            )
        },
        copyToClipboard(value, successMessage = 'Copiado') {
            const textToCopy = this.pickFirstDefined(value, '')
            if (!textToCopy || textToCopy === '-') {
                return
            }

            if (navigator?.clipboard?.writeText) {
                navigator.clipboard.writeText(String(textToCopy)).then(() => {
                    this.messageError = successMessage
                    this.typeOfMessage = 'success'
                    setTimeout(() => (this.messageError = ''), 3000)
                }).catch(() => {
                    this.messageError = 'No se pudo copiar al portapapeles'
                    this.typeOfMessage = 'error'
                    setTimeout(() => (this.messageError = ''), 3000)
                })
            }
        },
        normalizeOrderStatus(statusLike) {
            if (statusLike === null || statusLike === undefined || statusLike === '') {
                return {
                    id: '-',
                    name: 'Unknown'
                }
            }

            if (typeof statusLike === 'object') {
                const statusId = this.pickFirstDefined(statusLike.id, statusLike.value, statusLike.order_status_id)
                const statusName = this.pickFirstDefined(statusLike.name, statusLike.label, statusLike.order_status_name)

                return {
                    id: statusId ?? '-',
                    name: this.getReadableText(statusName ?? 'Unknown')
                }
            }

            const match = this.dataOrderStatusCombo.find((status) => String(status.id) === String(statusLike))
            return {
                id: statusLike,
                name: this.getReadableText(match ? match.name : 'Unknown')
            }
        },
        normalizeChangedByUser(userLike) {
            if (!userLike) {
                return {
                    name: 'System',
                    email: '-'
                }
            }

            if (typeof userLike === 'object') {
                const fullName = `${userLike.name || ''} ${userLike.lastname || ''}`.trim()
                return {
                    name: fullName || this.getReadableText(userLike.username || userLike.email || 'System'),
                    email: this.pickFirstDefined(userLike.email, userLike.username, '-')
                }
            }

            return {
                name: 'System',
                email: '-'
            }
        },
        async validate() {
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                this.update()
            } else {
                alert('Faltan parametros')
            }
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        getListCountry() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/country/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataCountryCombo = []
                        self.dataCountryCombo = response.data


                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListProvince(id) {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/country/' + id + '/provinces/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        self.dataProvinceCombo = []
                        self.dataProvinceCombo = response.data

                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListOrderStatus() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/order-status/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataOrderStatusCombo = []
                        self.dataOrderStatusCombo = response.data
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getDetailOrderGrid(options = {}) {
            let self = this
            this.loading = true

            const page = options.page || 1
            const itemsPerPage = options.itemsPerPage || this.itemsPerPage
            const sortBy = options.sortBy || []

            this.itemsPerPage = itemsPerPage
            
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/orderdetail/gridbyorder?page=' + page + '&limit=' + itemsPerPage + '&idorder=' + self.id 

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        const detailRows = (Array.isArray(response.data.data) ? response.data.data : []).filter(
                            (item) => item && typeof item === 'object'
                        )

                        self.dataDetailOrderGrid = detailRows.map((item) => ({
                            article_name: this.getReadableText(item.article_name),
                            quantity: item.quantity ?? 0,
                            price: item.price ?? 0,
                            discount: item.discount ?? 0,
                            line_total: Number((Number(item.quantity ?? 0) * Number(item.price ?? 0)).toFixed(2)),
                            has_discount: Number(item.discount ?? 0) > 0 ? 'Yes' : 'No'
                        }))

                        self.pagination.from = response.data.from
                        self.pagination.to = response.data.to
                        self.pagination.total = response.data.total
                        self.pagination.current = response.data.current_page
                        self.pagination.lastPage = response.data.last_page
                        
                        status = 'Success'
                    }
                }).catch((error) => {
                    this.messageError = 'Error! Obtener datos.'
                    this.typeOfMessage = 'error'
                    setTimeout(() => (this.messageError = ''), 10000)
                }).finally(() => {
                    this.loading = false
                })
                resolve(status)
            })
        },
        getShippingOrderGrid(options = {}) {
            let self = this
            this.loading = true

            const page = options.page || 1
            const itemsPerPage = options.itemsPerPage || this.itemsPerPageShipping
            const sortBy = options.sortBy || []

            this.itemsPerPageShipping = itemsPerPage
            
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/ordershipping/gridbyorder?page=' + page + '&limit=' + itemsPerPage + '&idorder=' + self.id 

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        const shippingRows = (Array.isArray(response.data.data) ? response.data.data : []).filter(
                            (item) => item && typeof item === 'object'
                        )

                        self.dataShippingOrderGrid = shippingRows.map((item) => ({
                            Order_shiping_id: this.pickFirstDefined(item.Order_shiping_id, item.order_shiping_id, item.order_shipping_id, item.id, '-'),
                            // La fuente de verdad de "es un envío de un solo producto" es order_detail_id
                            // (NULL = cubre todo el pedido), no si el join a Article trajo nombre/sku —
                            // ese join puede fallar (artículo renombrado/borrado) sin que deje de ser un
                            // envío de producto concreto.
                            product: this.pickFirstDefined(item.order_detail_id, item.orderDetailId) != null
                                ? ([this.getReadableText(this.pickFirstDefined(item.product_name, null)), item.product_sku].filter(v => v && v !== '-').join(' · ')
                                    || `Producto #${this.pickFirstDefined(item.order_detail_id, item.orderDetailId)}`)
                                : 'Todo el pedido',
                            cj_order_id: this.pickFirstDefined(item.cj_order_id, item.cjOrderId, '-'),
                            // Último orderStatus de CJ de esta sub-orden (CREATED, UNSHIPPED, SHIPPED,
                            // DELIVERED...): es lo que usa el backend para calcular el estado del pedido.
                            cj_order_status: this.pickFirstDefined(item.cj_order_status, item.cjOrderStatus, '-'),
                            tracking_number: this.pickFirstDefined(item.tracking_number, item.trackingNumber, '-'),
                            tracking_url: this.pickFirstDefined(item.tracking_url, item.trackingUrl, '-'),
                            carrier_name: this.getReadableText(this.pickFirstDefined(item.carrier_name, item.carrierName, item.carrier?.name, '-')),
                            // Tramo final: una vez el paquete llega al país de destino, el transportista
                            // local (USPS, Correos...) asigna su propio número, distinto de tracking_number.
                            // carrier_last_mile_url viene ya resuelto contra Carriers (auto-creado con URL
                            // genérica 17track si el transportista local es nuevo en esta instalación).
                            last_track_number: this.pickFirstDefined(item.last_track_number, item.lastTrackNumber, null),
                            last_mile_carrier: this.pickFirstDefined(item.last_mile_carrier, item.lastMileCarrier, null),
                            last_mile_carrier_url: this.pickFirstDefined(item.last_mile_carrier_url, item.lastMileCarrierUrl, null),
                            tracking_route: [this.pickFirstDefined(item.tracking_from, item.trackingFrom, null), this.pickFirstDefined(item.tracking_to, item.trackingTo, null)]
                                .filter(Boolean).join(' → ') || '-',
                            tracking_status: this.pickFirstDefined(item.tracking_status, item.trackingStatus, '-'),
                            estimated_delivery: this.pickFirstDefined(item.estimated_delivery, item.estimatedDelivery, '-'),
                            description: this.pickFirstDefined(item.description, '-'),
                            tracking_available: this.pickFirstDefined(item.tracking_number, item.trackingNumber) ? 'Yes' : 'No',
                            description_length: (this.pickFirstDefined(item.description, '') || '').length,
                            // logisticsTrackEvents del webhook CJ: historial completo (recogido/en tránsito/
                            // entregado...), no solo el último estado. Guardamos el array tal cual para pintarlo
                            // en el dialog de historial (ver openTrackingHistory).
                            tracking_events: Array.isArray(item.tracking_events)
                                ? item.tracking_events
                                : (Array.isArray(item.trackingEvents) ? item.trackingEvents : [])
                        }))

                        self.paginationShipping.from = response.data.from
                        self.paginationShipping.to = response.data.to
                        self.paginationShipping.total = response.data.total
                        self.paginationShipping.current = response.data.current_page
                        self.paginationShipping.lastPage = response.data.last_page
                        
                        status = 'Success'
                    }
                }).catch((error) => {
                    this.messageError = 'Error! Obtener datos.'
                    this.typeOfMessage = 'error'
                    setTimeout(() => (this.messageError = ''), 10000)
                }).finally(() => {
                    this.loading = false
                })
                resolve(status)
            })
        },
        getShipmentNotificationOrderGrid(options = {}) {
            let self = this
            this.loading = true

            const page = options.page || 1
            const itemsPerPage = options.itemsPerPage || this.itemsPerPageShipmentNotification
            const sortBy = options.sortBy || []

            this.itemsPerPageShipmentNotification = itemsPerPage

            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/ordershipmentnotification/gridbyorder?page=' + page + '&limit=' + itemsPerPage + '&idorder=' + self.id 

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        const notificationRows = (Array.isArray(response.data.data) ? response.data.data : []).filter(
                            (item) => item && typeof item === 'object'
                        )

                        self.dataShipmentNotificationOrderGrid = notificationRows.map((item) => ({
                            order_shipping_id: this.pickFirstDefined(item.order_shipping_id, item.orderShippingId, item.order_shipping?.id, '-'),
                            notification_method: this.getReadableText(this.pickFirstDefined(item.notification_method, item.notificationMethod, item.notification_method?.name, '-')),
                            order_status: this.getReadableText(this.pickFirstDefined(item.order_status, item.orderStatus, item.order_status?.name, '-')),
                            comment: this.pickFirstDefined(item.comment, '-'),
                            has_comment: this.pickFirstDefined(item.comment) ? 'Yes' : 'No',
                            comment_length: (this.pickFirstDefined(item.comment, '') || '').length,
                            created_at: this.getFormatUpdatedAt(this.pickFirstDefined(item.created_at, item.createdAt)),
                            updated_at: this.getFormatUpdatedAt(this.pickFirstDefined(item.updated_at, item.updatedAt))
                        }))

                        self.paginationShipmentNotification.from = response.data.from
                        self.paginationShipmentNotification.to = response.data.to
                        self.paginationShipmentNotification.total = response.data.total
                        self.paginationShipmentNotification.current = response.data.current_page
                        self.paginationShipmentNotification.lastPage = response.data.last_page
                        
                        status = 'Success'
                    }
                }).catch((error) => {
                    this.messageError = 'Error! Obtener datos.'
                    this.typeOfMessage = 'error'
                    setTimeout(() => (this.messageError = ''), 10000)
                }).finally(() => {
                    this.loading = false
                })
                resolve(status)
            })
        },
        getTransactionOrderGrid(options = {}) {
            let self = this
            this.loading = true

            const page = options.page || 1
            const itemsPerPage = options.itemsPerPage || this.itemsPerPageTransactionOrder
            const sortBy = options.sortBy || []

            this.itemsPerPageTransactionOrder = itemsPerPage

            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/ordertransaction/gridbyorder?page=' + page + '&limit=' + itemsPerPage + '&idorder=' + self.id 

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }
            

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        const transactionRows = (Array.isArray(response.data.data) ? response.data.data : []).filter(
                            (item) => item && typeof item === 'object'
                        )

                        self.dataTransactionOrderGrid = transactionRows.map((item) => ({
                            paymentMetadata: this.parseMetadata(this.pickFirstDefined(item.payment_metadata, null)),
                            checkoutCurrencyRaw: this.pickFirstDefined(item.checkout_currency, item.currency, item.currency_code),
                            checkoutCurrencyMultipleRaw: this.pickFirstDefined(item.checkout_currency_multiple),
                            transaction_number: this.pickFirstDefined(item.transaction_number, '-'),
                            payment_intent_id: this.pickFirstDefined(item.payment_intent_id, item.transaction_number, '-'),
                            charge_id: this.pickFirstDefined(item.charge_id, '-'),
                            balance_transaction_id: this.pickFirstDefined(item.balance_transaction_id, '-'),
                            total: this.pickFirstDefined(item.total, 0),
                            method: this.getReadableText(this.pickFirstDefined(item.method, '-')),
                            status: this.getReadableText(this.pickFirstDefined(item.Status, item.status, '-')),
                            payment_status: this.getReadableText(this.pickFirstDefined(item.payment_status, '-')),
                            payment_metadata: this.parseMetadata(this.pickFirstDefined(item.payment_metadata, null)),
                            description: this.pickFirstDefined(item.description, '-'),
                            created_at: this.getFormatUpdatedAt(this.pickFirstDefined(item.created_at, item.createdAt)),
                            updated_at: this.getFormatUpdatedAt(this.pickFirstDefined(item.updated_at, item.updatedAt)),
                            last4: this.pickFirstDefined(item.last4, '-')
                        })).map((item) => {
                            const visualStatus = this.normalizePaymentVisualStatus(item.payment_status, item.status)
                            const metadataCurrency = this.pickFirstDefined(item.paymentMetadata?.checkout_currency, item.paymentMetadata?.currency)
                            const metadataRate = this.pickFirstDefined(
                                item.paymentMetadata?.checkout_currency_multiple,
                                item.paymentMetadata?.exchange_rate,
                                item.paymentMetadata?.fx_rate
                            )
                            return {
                                ...item,
                                status_label: visualStatus.label,
                                status_color: visualStatus.color,
                                checkout_currency: this.normalizeCurrencyCode(this.pickFirstDefined(item.checkoutCurrencyRaw, metadataCurrency, 'USD'), 'USD'),
                                checkout_currency_multiple: this.getNumericValue(this.pickFirstDefined(item.checkoutCurrencyMultipleRaw, metadataRate))
                            }
                        })

                        this.updateFinancialSummary()

                        self.paginationTransactionOrder.from = response.data.from
                        self.paginationTransactionOrder.to = response.data.to
                        self.paginationTransactionOrder.total = response.data.total
                        self.paginationTransactionOrder.current = response.data.current_page
                        self.paginationTransactionOrder.lastPage = response.data.last_page
                        
                        status = 'Success'
                    }
                }).catch((error) => {
                    this.messageError = 'Error! Obtener datos.'
                    this.typeOfMessage = 'error'
                    setTimeout(() => (this.messageError = ''), 10000)
                }).finally(() => {
                    this.loading = false
                })
                resolve(status)
            })
        },
        getStatusHistoryGrid(options = {}) {
            let self = this
            this.loading = true

            const page = options.page || 1
            const itemsPerPage = options.itemsPerPage || this.itemsPerPageStatusHistory
            const sortBy = options.sortBy || []

            this.itemsPerPageStatusHistory = itemsPerPage

            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/orderstatushistory/gridbyorder?page=' + page + '&limit=' + itemsPerPage + '&idorder=' + self.id 

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }
            

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        const historyRows = (Array.isArray(response.data.data) ? response.data.data : []).filter(
                            (item) => item && typeof item === 'object'
                        )

                        // Transform data for better readability
                        self.dataStatusHistoryGrid = historyRows.map((item) => {
                            const statusInfo = this.normalizeOrderStatus(
                                this.pickFirstDefined(item.order_status, item.orderStatus, item.status, item.os)
                            )
                            const userInfo = this.normalizeChangedByUser(
                                this.pickFirstDefined(item.changed_by_user, item.changedByUser, item.user, item.u)
                            )

                            return {
                                id: this.pickFirstDefined(item.id, item.history_id, item.h?.id, '-'),
                                created_at: this.getFormatUpdatedAt(this.pickFirstDefined(item.created_at, item.createdAt, item.h?.createdAt, item.h?.created_at)),
                                status_name: statusInfo.name,
                                status_id: statusInfo.id,
                                user_name: userInfo.name,
                                user_email: userInfo.email,
                                comment: this.pickFirstDefined(item.comment, item.h?.comment, '-')
                            }
                        })

                        self.paginationStatusHistory.from = response.data.from
                        self.paginationStatusHistory.to = response.data.to
                        self.paginationStatusHistory.total = response.data.total
                        self.paginationStatusHistory.current = response.data.current_page
                        self.paginationStatusHistory.lastPage = response.data.last_page
                        
                        this.loading = false
                        status = 'Success'
                    }
                }).catch((error) => {
                    this.messageError = 'Error! Obtener datos.'
                    this.typeOfMessage = 'error'
                    setTimeout(() => (this.messageError = ''), 10000)
                }).finally(() => {
                    this.loading = false
                })
                resolve(status)
            })
        },
        getCjSyncLogs() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/order/cj-sync-logs/' + self.id

            return axios({
                url: apiURL,
                method: 'GET',
                responseType: 'json'
            }).then((response) => {
                const rows = Array.isArray(response.data?.data) ? response.data.data : []
                self.cjSyncLogs = rows.map((item) => ({
                    id: item.id,
                    fecha: item.fecha,
                    nivel: item.nivel,
                    mensaje: item.mensaje,
                    contexto: item.contexto
                }))
            }).catch(() => {
                // No se interrumpe la carga de la pagina si falla esta traza tecnica:
                // es informacion de apoyo, no un dato imprescindible del pedido.
                self.cjSyncLogs = []
            })
        },
        openCjSyncLogDetail(item) {
            this.selectedCjSyncLog = item
            this.isCjSyncLogDialogOpen = true
        },
        goToOrderLogs() {
            this.$router.push({ path: '/logs', query: { idorder: this.id } })
        },
        getOrder() {
            let self = this

            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/order/details_id/' + this.id
            
            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        self.orderNumber = response.data.orderNumber                   
                        self.orderStatus = response.data.orderStatus

                        self.total = response.data.total
                        self.user = response.data.user.email || response.data.user.username
                        
                        // Datos adicionales del cliente
                        self.customerName = (response.data.user.name || '') + ' ' + (response.data.user.lastname || '')
                        self.customerPhone = response.data.user.phone || 'N/A'
                        self.customerDocument = (response.data.user.documentType ? response.data.user.documentType.name : '') + ' ' + (response.data.user.documentNumber || '')

                        // Datos de seguimiento
                        self.voucherNumber = response.data.voucherNumber || 'N/A'
                        self.cjDropshippingId = response.data.requestidordercj || 'N/A'

                        self.createdAt = self.getFormatUpdatedAt(response.data.createdAt)
                        self.updatedAt = self.getFormatUpdatedAt(response.data.updatedAt)

                        self.address = response.data.address
                        self.addressnumber = response.data.addressNumber
                        self.country = response.data.country
                        self.province = response.data.province
                        self.city = response.data.city
                        self.postalcode = response.data.postalCode

                        self.orderDetails = response.data.orderDetails

                        this.applyPaymentBusinessValidation()
                        
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        update() {
            let newObject = {
                id: this.id,
                ordernumber : this.orderNumber,
                address : this.address,
                addressnumber : this.addressnumber,
                city : this.city,
                postalcode : this.postalcode,
            }

            if(this.orderStatus && this.orderStatus.id){
                newObject.orderstatus_id = this.orderStatus.id
            }
            if(this.country && this.country.id){
                newObject.country_id = this.country.id
            }
            if(this.province && this.province.id){
                newObject.province_id = this.province.id
            }

             axios.post('http://localhost:8001/admin/order/update', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha modificado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
            })
        }
    },
    async created() {
        this.id = this.$route.params.id
        await this.getListCountry()
        await this.getListOrderStatus()
        await this.getOrder()
        await this.getDetailOrderGrid({ page: 1, itemsPerPage: this.itemsPerPage, sortBy: [] })
        await this.getShippingOrderGrid({ page: 1, itemsPerPage: this.itemsPerPageShipping, sortBy: [] })
        await this.getShipmentNotificationOrderGrid({ page: 1, itemsPerPage: this.itemsPerPageShipmentNotification, sortBy: [] })
        await this.getTransactionOrderGrid({ page: 1, itemsPerPage: this.itemsPerPageTransactionOrder, sortBy: [] })
        await this.getStatusHistoryGrid({ page: 1, itemsPerPage: this.itemsPerPageStatusHistory, sortBy: [] })
        await this.getCjSyncLogs()
        this.cargado=true
    }
}
</script>

<style>
.order-information-fields .row {
    --bs-gutter-y: 0.25rem;
}

@media (min-width: 1200px) {
    .order-information-fields {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        column-gap: 1rem;
    }

    .order-information-fields > .row {
        margin-left: 0;
        margin-right: 0;
    }

    .order-information-fields .form-label-title.col-sm-2 {
        white-space: normal;
    }
}

.order-information-fields .mb-4.row.align-items-center {
    margin-bottom: 0.45rem !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    align-items: start !important;
    row-gap: 0.2rem;
}

.order-information-fields .form-label-title {
    font-size: 0.9rem;
    line-height: 1.2;
    margin-bottom: 0.25rem !important;
    width: 100%;
    max-width: 100%;
    flex: 0 0 auto;
}

.order-information-fields .mb-4.row.align-items-center > .col-sm-10,
.order-information-fields .mb-4.row.align-items-center > .col-sm-2 {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding-left: 0;
    padding-right: 0;
}

.order-information-fields .v-input {
    margin-bottom: 0 !important;
}

.order-information-fields .v-field {
    min-height: 40px;
}

.order-information-fields .v-field__input {
    min-height: 40px !important;
    padding-top: 6px;
    padding-bottom: 6px;
}

.transaction-order-table .v-table__wrapper {
    overflow-x: auto;
}

.transaction-order-data-table table {
    table-layout: fixed !important;
    min-width: 1560px;
    width: 100%;
}

.transaction-order-data-table th,
.transaction-order-data-table td {
    white-space: nowrap;
    vertical-align: middle;
    overflow: hidden;
}

.transaction-order-data-table td > .d-flex {
    min-width: 0;
    width: 100%;
    overflow: hidden;
    align-items: center;
}

.transaction-order-data-table td > .d-flex > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.transaction-order-data-table th:nth-child(1),
.transaction-order-data-table td:nth-child(1) {
    width: 180px;
}

.transaction-order-data-table th:nth-child(2),
.transaction-order-data-table td:nth-child(2) {
    width: 220px;
}

.transaction-order-data-table th:nth-child(3),
.transaction-order-data-table td:nth-child(3) {
    width: 200px;
}

.transaction-order-data-table th:nth-child(4),
.transaction-order-data-table td:nth-child(4) {
    width: 110px;
}

.transaction-order-data-table th:nth-child(5),
.transaction-order-data-table td:nth-child(5) {
    width: 140px;
}

.transaction-order-data-table th:nth-child(6),
.transaction-order-data-table td:nth-child(6) {
    width: 140px;
}

.transaction-order-data-table th:nth-child(7),
.transaction-order-data-table td:nth-child(7),
.transaction-order-data-table th:nth-child(8),
.transaction-order-data-table td:nth-child(8) {
    width: 160px;
}

.transaction-order-data-table th:nth-child(9),
.transaction-order-data-table td:nth-child(9) {
    width: 100px;
}

.transaction-order-data-table th:nth-child(10),
.transaction-order-data-table td:nth-child(10) {
    width: 120px;
}

.admin-action-textarea textarea {
    color: #000000 !important;
    -webkit-text-fill-color: #000000 !important;
}

.admin-action-textarea .v-field__input {
    color: #000000 !important;
}

.admin-action-textarea .v-label {
    color: #000000 !important;
    opacity: 0.85;
}

.tracking-history-timeline {
    position: relative;
    padding-left: 20px;
    border-left: 2px solid #e0e0e0;
}

.tracking-history-event {
    position: relative;
    padding-bottom: 16px;
}

.tracking-history-event:last-child {
    padding-bottom: 0;
}

.tracking-history-event-dot {
    position: absolute;
    left: -25px;
    top: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #757575;
}

.tracking-history-event-date {
    font-size: 0.8rem;
    color: #757575;
}

.tracking-history-event-status {
    font-weight: 600;
    font-size: 0.85rem;
}

.tracking-history-event-detail {
    font-size: 0.85rem;
    color: #212121;
}

.cj-sync-log-context {
    white-space: pre-wrap;
    word-break: break-word;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 12px;
    font-size: 0.8rem;
    max-height: 400px;
    overflow-y: auto;
}
</style>
